import React, { FormEvent, useState } from "react";
import { IbanElement, useElements, useStripe } from "@stripe/react-stripe-js";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DayJSUtils from "@date-io/dayjs";
import dayjs from "dayjs";
import "./home.css";
import "./normalize.css";

const Home = () => {
  //IT40S0542811101000000123456
  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [prezzo, setPrezzo] = useState<string>("");
  const [confirmationIBAN, setConfirmationIBAN] = useState<string>("");
  const [isSubscription, setIsSubscription] = useState<boolean>(false);
  const [processing, setProcessing] = useState<boolean>(false);

  const today = `${new Date().getFullYear()}-${new Date().getMonth() + 1}-${new Date().getDate()}`

  const [selectedDate, setSelectedDate] = useState<number>(dayjs(today).valueOf());

  const elements = useElements();
  const stripe = useStripe();

  const sendPayment = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const ibanElement = elements?.getElement(IbanElement);

    try {
      setProcessing(true);
      axios
        .post(
          process.env.REACT_APP_STRIPE_API_URL!,
          {
            paymentInfos: {
              amount: prezzo,
              customerName: name,
              causale: description,
              customerEmail: email,
              isSubscription,
              confirmationIBAN,
              subScriptionStartDate: selectedDate
            },
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then(async (res) => {
          const result = await stripe?.confirmSepaDebitPayment(
            res.data.clientSecret,
            {
              payment_method: {
                sepa_debit: ibanElement!,
                billing_details: {
                  email: email!,
                  name: name!,
                },
                metadata: {
                  description: description!,
                },
              },
            }
          );
          if (result?.error) {
            alert(`Errore!, ${result.error.message}`);
            setProcessing(false);
          } else {
            alert("Pagamento eseguito con successo");
            setProcessing(false);
            setName("");
            setDescription("");
            setPrezzo("");
            setEmail("");
            setConfirmationIBAN("");
          }
        })
        .catch((error) => {
          alert(error.message);
          setProcessing(false);
        });
    } catch (error) {
      alert(error.message);
      setProcessing(false);
    }
  };

  return (
    <div className="sr-root">
      <div className="sr-main">
        <img src={`../res/logo.png`} alt="Logo" />
        <form
          id="payment-form"
          className="sr-payment-form"
          onSubmit={(e) => sendPayment(e)}
        >
          <div className="sr-combo-inputs-row">
            <div className="col">
              <label htmlFor="name">Nome</label>
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                id="name"
                name="name"
                placeholder="Nome Cognome"
                required
              />
            </div>
            <div className="col">
              <label htmlFor="email">Email</label>
              <input
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                id="email"
                name="email"
                type="email"
                placeholder="email@esempio.com"
                required
              />
            </div>
          </div>

          <div className="sr-combo-inputs-row">
            <div className="col">
              <label htmlFor="description">Descrizione</label>
              <div id="description">
                <input
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  id="description"
                  name="description"
                  placeholder="RATA 1 NOME PRODOTTO"
                  required
                />
              </div>
            </div>

            <div>
              <label htmlFor="price">Cifra</label>
              <div id="prezzo">
                <input
                  value={prezzo}
                  onChange={(e) => setPrezzo(e.target.value)}
                  id="prezzo"
                  name="prezzo"
                  placeholder="000.00 €"
                  required
                />
              </div>
            </div>
          </div>

          <FormControlLabel
            control={
              <Checkbox
                onChange={(e) => {
                  setIsSubscription(e.target.checked);
                }}
                checked={isSubscription}
              />
            }
            label="Pagamento Ricorrente"
          />

          <MuiPickersUtilsProvider utils={DayJSUtils} locale="it">
            <Typography style={{color: "gray"}}>Data Inizio Abbonamento</Typography>
            <KeyboardDatePicker
              disabled={!isSubscription}
              variant="inline"
              format="DD/MM/YYYY"
              margin="normal"
              id="date-picker-inline"
              label="Data Inizio Abbonamento"
              value={selectedDate}
              onChange={(date) => {
                setSelectedDate(date?.valueOf()!);
                console.log(date?.valueOf())
              }}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
            />
          </MuiPickersUtilsProvider>

          <div className="col">
            <label htmlFor="iban-element">IBAN</label>
            <IbanElement
              options={{
                supportedCountries: ["SEPA"],
                placeholderCountry: "IT",
                style: {
                  base: {
                    color: "white",
                    "::placeholder": {
                      color: "gray",
                    },
                  },
                },
              }}
            />
          </div>

          <div className="sr-combo-inputs-row">
            <div className="col">
              <label htmlFor="description">Conferma IBAN</label>
              <div id="IBAN">
                <input
                  value={confirmationIBAN}
                  onChange={(e) => setConfirmationIBAN(e.target.value)}
                  id="confirmationIBAN"
                  name="confirmationIBAN"
                  placeholder="IT ..."
                  required
                />
              </div>
            </div>
          </div>

          <div id="error-message" className="sr-field-error" role="alert"></div>
          <Typography hidden={processing === false} style={{ color: "green" }}>
            Pagamento in corso...
          </Typography>
          <button id="confirm-mandate" disabled={processing}>
            <div className="spinner hidden" id="spinner"></div>
            <span id="button-text">
              Paga
              <span id="order-amount"></span>
            </span>
          </button>
        </form>
        <div className="sr-result hidden">
          <p>
            Payment processing
            <br />
          </p>
          <pre>
            <code></code>
          </pre>
        </div>
      </div>
    </div>
  );
};

export default Home;
